export const environment = {
  production: false,
  version: '1.11.0',
};
